// @flow

// Components
import EditIcon from 'fc-icons/src/Pencil'
import Button from '@react-mdc/button'

// Libs
import React, { Component } from 'react'

// Styles
import { white } from 'hfty-styles/src/colors'

// Props
type Props = {
  title: string,
  onClick: Function,
}

// TODO: Fix styling on this
const style = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 'initial',
  },
}
export default class AddJobButton extends Component {
  props: Props

  render (): ?React.Element<any> {
    const title = this.props.title ? this.props.title : ''
    return (
      <div title={title} >
        <Button raised onClick={this.props.onClick} style={style.button} >
          <EditIcon color={white()} />
        </Button>
      </div>
    )
  }
}
